import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import Loading from "../../components/Loading";

import Item from './components/Item';

import Data from '../../../repository';

import styles from '../../../styles/Admin.module.scss';

function List() {
	const [loading, setLoading] = useState(true);
	const [membershipPlans, setMembershipPlans] = useState([]);

	useEffect(async () => {
		await refreshMembershipPlans();
	}, [])

	const refreshMembershipPlans = async () => {
		setLoading(true);
		let membershipPlans = await Data.fetchMembershipPlans();
		membershipPlans = membershipPlans.data.sort((a, b) => {
			return b.active - a.active
		})
		setMembershipPlans(membershipPlans);
		setLoading(false);
	}

	if(loading) return <Loading button={false} />

	return (
		<div className={styles.list}>
			{!membershipPlans.length && <div><p>There aren't any membership plans to show.</p></div>}

			{membershipPlans.map((membershipPlan) => {
				return <Item {...membershipPlan} />
			})}
		</div>
	)
}

export default List;